
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Table from "../ErrorTab/Table";
import Filtering from "../RuleCatalogue/Filtering";
import { Skeleton, Box } from "@mui/material";
import heartLoading from "../../assests/heartLoading.gif";
import preloader from "../../assests/preloader1.gif";



const ErrorDetails = ({
  productId = null,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [data, setData] = useState({
    "tableData": [
      {
          "ruleId": "EF8BC525-A94B-4FA9-B803-023E9D960A70",
          "ruleName": "avg_rating _check4and5",
          "dqDimension": "validity",
          "rulePhase": "N/A",
          "ruleOwner": "N/A",
          "dataAssetName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345",
          "failPercentageVsThreshold": "7.0% vs 2%",
          "breachDate": "N/A",
          "Status": "N/A",
          "Ticket": "N/A"
      },
      {
          "ruleId": "122FC220-F6DF-41EF-A28E-D329BCDD364C",
          "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_feedback_avg_rating_is_equal_to",
          "dqDimension": "accuracy",
          "rulePhase": "N/A",
          "ruleOwner": "N/A",
          "dataAssetName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345",
          "failPercentageVsThreshold": "66.0% vs 1%",
          "breachDate": "N/A",
          "Status": "N/A",
          "Ticket": "N/A"
      },
      {
          "ruleId": "3ED40412-648C-4594-ABA1-6604386AEEE1",
          "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_feedback_avg_rating_is_not_null",
          "dqDimension": "completeness",
          "rulePhase": "N/A",
          "ruleOwner": "N/A",
          "dataAssetName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345",
          "failPercentageVsThreshold": "34.0% vs 2%",
          "breachDate": "N/A",
          "Status": "N/A",
          "Ticket": "N/A"
      },
      {
          "ruleId": "F276786A-AAD4-43E9-9861-305F4B207DE7",
          "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_feedback_comment_count_is_not_less_than",
          "dqDimension": "validity",
          "rulePhase": "N/A",
          "ruleOwner": "N/A",
          "dataAssetName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345",
          "failPercentageVsThreshold": "61.0% vs 4%",
          "breachDate": "N/A",
          "Status": "N/A",
          "Ticket": "N/A"
      },
      {
          "ruleId": "2C022219-1A9C-4CBF-AF20-8283A811E035",
          "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_retailer_product_name_is_not_null",
          "dqDimension": "completeness",
          "rulePhase": "N/A",
          "ruleOwner": "N/A",
          "dataAssetName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345",
          "failPercentageVsThreshold": "0.5% vs 5%",
          "breachDate": "N/A",
          "Status": "N/A",
          "Ticket": "N/A"
      },
      {
          "ruleId": "3EB18C0D-A472-479E-A8E0-0631997FEC89",
          "ruleName": "snacking_snackingdataquality|global_x_seg_availability_sample_12345_retailer_product_id_regex_match",
          "dqDimension": "validity",
          "rulePhase": "N/A",
          "ruleOwner": "N/A",
          "dataAssetName": "snacking_snackingdataquality|global_x_seg_availability_sample_12345",
          "failPercentageVsThreshold": "4.0% vs 5%",
          "breachDate": "N/A",
          "Status": "N/A",
          "Ticket": "N/A"
      },
      {
          "ruleId": "0AB5341D-4FFB-4F10-8F15-936E9B840924",
          "ruleName": "snacking_snackingdataquality|global_x_seg_availability_sample_12345_status_is_in_list",
          "dqDimension": "validity",
          "rulePhase": "N/A",
          "ruleOwner": "N/A",
          "dataAssetName": "snacking_snackingdataquality|global_x_seg_availability_sample_12345",
          "failPercentageVsThreshold": "0.5% vs 5%",
          "breachDate": "N/A",
          "Status": "N/A",
          "Ticket": "N/A"
      }
  ],
  "filters": {
      "name": [
          "Region",
          "Market",
          "Retailer",
          "Category/Brand",
          "Product"
      ],
      "list": {
          "Region": [
              "",
              "Latin America"
          ],
          "Market": [
              "",
              "Mexico"
          ],
          "Retailer": [
              "",
              "Tesco"
          ],
          "Category/Brand": [
              "",
              "Chocolate"
          ],
          "Product": [
              "",
              "Snickers"
          ]
      },
      "rulePhase": [
          "Post - Refresh",
          "Pre - Refresh"
      ]
  },
  "pagination": {
      "currentPage": 1,
      "pageSize": 10,
      "totalPages": 1,
      "totalRecords": 7
  },
  "errorPreviews": {}

  }); // will hold server payload (tableData, filters, pagination)
  const initialLoaded = useRef(false);
  const [loading, setLoading] = useState(false);


  // useEffect(() => {
  //   const payload = {
  //     productId,
  //     filters: currentFilters,
  //     searchTerm,
  //     page,
  //     pageSize,
  //   };

  //   axios
  //     .post(`${BASE_URL}/error-details-results`, payload)
  //     .then((res) => {
  //       const resData = res.data;
  //       setData((prev) =>
  //         initialLoaded.current
  //           ? {
  //               // merge so frontend local changes remain if server doesn't return them
  //               ...prev,
  //               tableData: resData.tableData ?? prev?.tableData,
  //               filters: resData.filters ?? prev?.filters,
  //               pagination: resData.pagination ?? prev?.pagination,
  //             }
  //           : // on first load take server response as-is
  //             resData
  //       );
  //       initialLoaded.current = true;
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching error-details payload:", err);
  //     })
  //      .finally(() => {
  //   setLoading(false);
  // });
  // }, [currentFilters, searchTerm, page, pageSize, productId, BASE_URL]);

  const handlePageChange = (p) => {
    setLoading(true);
    setPage(p);
  };

if (!data) {
    // Skeleton loading UI
    return (
         <div className="relative bg-white flex items-center justify-center z-50 min-h-screen">
       <div className="flex flex-col items-center space-y-3">
         <img src={preloader} alt="Loading..." width={200} />
         <span className="text-gray-700 text-[20px] text-center">
           Hang tight! The resources are loading...
         </span>
       </div>
     </div>
    );
  }
  
  

  return (
    <div className="error-detailss">
      <Filtering
        availableFilters={data.filters}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
      />

      <Table
        tableData={data.tableData}
        pagination={data.pagination}
        onPageChange={handlePageChange}
        errorPreviews={data.errorPreviews}
         loading={loading}

      />
    </div>
  );
};

export default ErrorDetails;

